/* RESPONSIBLE TEAM: team-frontend-tech */
import { computed } from '@ember/object';
import Predicate from 'predicates/models/predicate';
const USER_TYPES = {
  user_role: 'user',
  contact_role: 'lead',
  visitor_role: 'visitor'
};
const ROLE_TO_USERTYPE_LIST_MAP = {
  user: ['user_role'],
  lead: ['contact_role'],
  visitor: ['visitor_role'],
  non_user: ['contact_role', 'visitor_role'],
  non_lead: ['user_role', 'visitor_role'],
  non_visitor: ['contact_role', 'user_role'],
  everyone: ['contact_role', 'user_role', 'visitor_role']
};
export default Predicate.extend({
  isRoot: true,
  isEditable: false,
  isRoleType: true,
  isUserPredicate: true,
  genericType: 'role',
  getDefaultValue() {
    return 'user_role';
  },
  getDefaultComparison(context = {}) {
    if (context.mode === 'vam') {
      return 'ne';
    }
    return 'eq';
  },
  changeUserType(userType) {
    if (userType.startsWith('non_')) {
      this._changeToNegatedPredicate(userType);
    } else if (userType === 'everyone') {
      this._changeToEveryonePredicate();
    } else {
      this._changeToStandardPredicate(userType);
    }
  },
  userType: computed('value', 'comparison', function () {
    let userType = USER_TYPES[this.value];
    if (this.comparison === 'in') {
      return this._typeForInComparison();
    }
    if (userType || this.comparison === 'known') {
      return this._typeForSingleRole(userType);
    }
    throw new Error('not a valid user type');
  }),
  userTypes: computed('value', function () {
    let predicateValues = this.value;
    let values = predicateValues.map(v => {
      if (!(v in USER_TYPES)) {
        throw new Error(`Unknown predicate value ${v}`);
      }
      return USER_TYPES[v];
    });
    return values;
  }),
  _getRole(userType) {
    let types = Object.keys(USER_TYPES);
    let role = types.find(type => USER_TYPES[type] === userType);
    if (role) {
      return role;
    } else if (this.comparison === 'known') {
      return 'everyone';
    }
    throw new Error('not a valid user type');
  },
  _typeForSingleRole(role) {
    switch (this.comparison) {
      case 'ne':
        return `non_${role}`;
      case 'eq':
        return role;
      case 'known':
        return 'everyone';
      default:
        throw new Error(`not a valid user comparison for single role`);
    }
  },
  _typeForInComparison() {
    let userRoles = this.value;
    return Object.keys(ROLE_TO_USERTYPE_LIST_MAP).find(key => {
      return _.isEqual(ROLE_TO_USERTYPE_LIST_MAP[key].sort(), userRoles.sort());
    });
  },
  _changeToNegatedPredicate(userType) {
    let role = userType.split('_')[1];
    let mappedRole = this._getRole(role);
    this.changeValue(mappedRole);
    this.changeComparison('ne');
  },
  _changeToEveryonePredicate() {
    this.changeValue(null);
    this.changeComparison('known');
  },
  _changeToStandardPredicate(userType) {
    let mappedRole = this._getRole(userType);
    this.changeValue(mappedRole);
    this.changeComparison('eq');
  }
});